import type { Cart } from "@packages/sdk";

export const useSubscriptionPeriod = ({ product }: Pick<Cart, "product">) => {
  if (product.external_id.includes("yearly")) return "year";
  if (product.external_id.includes("monthly")) return "month";
  return "other";
};
